import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      padding: '0',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardContainer: {
      '&&': {
        minHeight: 310,
      },
    },
  })
);

export default useStyles;
